<!-- Original Template -->
<div
  *ngIf="!enableMachCoreProfileSelector"
  id="profile_modal_header"
  class="profile-modal-header"
>
  <idp-logo-header
    [logoUrl]="profileHeaderContent.logoUrl"
    [altText]="profileHeaderContent.altText"
  ></idp-logo-header>
  <div class="row mx-0">
    <h1 class="profile-modal-header__header-title">
      {{ profileHeaderContent.headerTitle }}
    </h1>
  </div>
  <div
    *ngIf="profileHeaderContent.headerSubTitle"
    class="profile-modal-header__fields-required-text"
    [ngClass]="{
      'remove-margin-bottom':
        profileHeaderContent.contentBodyHeader !== undefined
    }"
    aria-live="polite"
  >
    {{ profileHeaderContent.headerSubTitle }}
  </div>
  <div
    *ngIf="profileHeaderContent.contentBodyHeader"
    class="profile-modal-header__content-body-header"
  >
    {{ profileHeaderContent.contentBodyHeader }}
  </div>
</div>

<!-- New MachCore Template -->
<div
  *ngIf="enableMachCoreProfileSelector"
  id="profile_modal_header_machcore"
  class="profileModalHeaderMachCore"
>
  <div
    *ngIf="profileHeaderContent.headerSubTitle"
    class="profileModalHeaderMachCore__subtitle mb-[20px] mt-[22px] text-[.75rem] font-[400] leading-[.875rem] text-[#0b1f66] w-[16rem]"
    [ngClass]="{
      'mb-0': profileHeaderContent.contentBodyHeader !== undefined
    }"
    aria-live="polite"
  >
    {{ profileHeaderContent.headerSubTitle }}
  </div>
  <div
    *ngIf="profileHeaderContent.contentBodyHeader"
    class="profileModalHeaderMachCore__content-header mt-[1.375rem] mb-[32px] text-[12px] leading-[14px] font-[400] text-[#0b1f66] pr-[0.9375rem]"
  >
    {{ profileHeaderContent.contentBodyHeader }}
  </div>
</div>
